import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b521e7a4"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailsProduct: require('/var/www/html/fantini/frontend-2/components/details/product/index.vue').default,Btn: require('/var/www/html/fantini/frontend-2/components/btn/index.vue').default,ModalNeedsUser: require('/var/www/html/fantini/frontend-2/components/modal/needs-user/index.vue').default})
